import { InputNumber } from "primereact/inputnumber";

// Icons
import { TbPigMoney } from "react-icons/tb";

// Types
import type { ITerrainProps } from "./types";

// Models

// Services

export function Terrain({CERTIFICATIONS,ITBI,REGISTER,batchAmount,TOTAL_TERRAIN,setBatchAmount}: ITerrainProps) {


    return (
        <span style={{
            maxWidth: 'calc(50% - 0.75rem)',
            minWidth: 'calc(50% - 0.75rem)',
        }} className="max-sm:!w-full max-sm:!min-w-full max-sm:!max-w-full md:flex-1 h-auto flex flex-col justify-between gap-3
                rounded-xl
                border-slate-200 border-[1px]
                bg-white shadow-md overflow-hidden
            "
        >
            <span className="w-full flex flex-row items-center gap-2 px-4 pt-4 pb-2 border-slate-200 border-b-[1px]">
                <TbPigMoney size={25} />
                <span className="font-semibold">Terreno</span>
            </span>

            <span className="w-full h-auto flex flex-col gap-3 p-4">
                <span className="w-full h-auto flex flex-row items-center justify-between gap-4">
                    <span>Valor do lote</span>
                    <InputNumber
                        mode="currency"
                        currency="BRL"
                        locale="pt-BR"
                        minFractionDigits={2}
                        value={batchAmount}
                        onValueChange={(e) => setBatchAmount(e.value || 0)}
                    />
                </span>

                {/* <span className="w-full h-auto flex flex-row items-center justify-between">
                    <span>Entrada (volta no financ.)</span>
                    <InputNumber
                        mode="currency"
                        currency="BRL"
                        locale="pt-BR"
                        minFractionDigits={2}
                        value={0}
                        // onValueChange={(e) => setEntryAmount(e.value || 0)}
                    />
                    <span className="font-semibold">
                        {
                            Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                                unitDisplay: 'long'
                            }).format(entryAmount)
                        }
                    </span>
                </span> */}

                <span className="w-full h-auto flex flex-row items-center justify-between">
                    <span>ITBI</span>
                    {/* <span className="font-semibold">
                        {
                            Intl.NumberFormat('pt-BR', {
                                style: 'percent',
                                unitDisplay: 'long'
                            }).format(ITBI)
                        }
                    </span> */}
                    <span className="font-semibold">
                        {
                            Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                                currencyDisplay: 'symbol'
                            }).format(ITBI)
                        }
                    </span>
                </span>

                <span className="w-full h-auto flex flex-row items-center justify-between">
                    <span>Registro</span>
                    <span className="font-semibold">
                        {
                            Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                                currencyDisplay: 'symbol'
                            }).format(REGISTER)
                        }
                    </span>
                </span>

                <span className="w-full h-auto flex flex-row items-center justify-between">
                    <span>Certidões</span>
                    <span className="font-semibold">
                        {
                            Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                                currencyDisplay: 'symbol'
                            }).format(CERTIFICATIONS)
                        }
                    </span>
                </span>
            </span>

            <span className="w-[90%] self-end h-auto flex flex-col items-end gap-2 bg-slate-200 p-4">
                {/* <span className="font-semibold">
                    {
                        Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                            currencyDisplay: 'symbol'
                        }).format(0)
                    }
                </span> */}
                <span className="w-full flex flex-row items-center justify-end gap-5">
                    <span className="font-bold">Custos total</span>
                    <span className="font-bold">
                        {
                            Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                                currencyDisplay: 'symbol'
                            }).format(TOTAL_TERRAIN)
                        }
                    </span>
                </span>
            </span>
        </span>
    )
}
